import {
	PromiseExtended, Table,
} from 'dexie';
import {
	useLiveQuery,
} from 'dexie-react-hooks';
import {
	useState,
} from 'react';
import {
	getBasePath,
	http as httpClient,
} from 'utils/http';

/**
 * Use this function to avoid duplicating code,
 * when creating new services.
 *
 * A service is used to avoid cluttering the components with non render related logic
 * @param table
 */
export const useBasisService = <T extends unknown>(
	/**
   * The table that the live query wil
   */
	table: Table,
	/**
   * The liveQuery to be used
   */
	liveQuery: (t: Table) => PromiseExtended = (t: Table) => t.toArray()
) => ({
		data: useLiveQuery<T>(() => liveQuery(table)),
		table,
		loading: useState<boolean>(false),
		error: useState<{[key: string]: any} | string | null>(null),
		http: httpClient,
		/**
	 	* The default base path, which is for the TC services
	 	*/
		baseUrl: getBasePath(),
	});